export default __webpack_public_path__ + "static/hongKong-9ebcc154231c512b2bd341a3c07ab53b.svg";